import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { LotteryDashboardComponent } from './lottery-dashboard/lottery-dashboard';
import { BetslipPageModule } from './betslip/betslip.module';
import { LotteryDetailPageModule } from './lottery-detail/lottery-detail.module';
import { LotteryMenuPageModule } from './lottery-menu-page/lottery-menu-page.module';
import { SharedModule } from '../shared/shared.module';
import { PrizeLevelModalPageModule } from './prize-level-modal/prize-level-modal.module';
import { BaselineSharedModule } from 'baseline-lib';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { SundayRaffleDetailPageModule } from './sunday-raffle-detail/sunday-raffle-detail.module';

@NgModule({
  declarations: [
    LotteryDashboardComponent
  ],
  imports: [
    BetslipPageModule,
    LotteryDetailPageModule,
    LotteryMenuPageModule,
    SharedModule,
    PrizeLevelModalPageModule,
    BaselineSharedModule,
    LazyLoadImageModule,
    SundayRaffleDetailPageModule,
    IonicPageModule.forChild(LotteryModule),
  ],
  exports: [
    LotteryDashboardComponent,
    LotteryMenuPageModule,
    SundayRaffleDetailPageModule
  ]
})
export class LotteryModule {}



// WEBPACK FOOTER //
// ./src/app/lottery/lottery.module.ts